import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { PassengersService } from "../passengers.service";
import { Passenger } from "../../shared/models/passenger.model";
import { debounceTime, finalize, switchMap, tap } from "rxjs/operators";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { Country, SharedService } from "../../shared/shared.service";
import { LocalStorageService } from "../../shared/local-storage.service";
import moment from "moment";

@Component({
    selector: "app-assigne-passengers-to-flight",
    templateUrl: "./assigne-passengers-to-flight.component.html",
    styleUrls: ["./assigne-passengers-to-flight.component.scss"],
    standalone: false,
})
export class AssignePassengersToFlightComponent {
    @ViewChild("passengersForm", { static: false }) passengersForm: NgForm;
    public passengerFormGroup: FormGroup;
    public maxBirthDay = new Date();
    public countries: Country[] = [];

    // WE-3020
    public searchedPassengers: Passenger[] = [];
    public flightPassengers: Passenger[] = [];
    public flightCodeFormControl = new FormControl("");
    public passengerNameFormControl = new FormControl("");
    public passengerNameIsLoading = false;
    public filteredPassengersOptions: Passenger[];

    constructor(
        public dialogRef: MatDialogRef<AssignePassengersToFlightComponent>,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            passengerId: number;
            flightId: number;
        },
        private _passengersService: PassengersService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _formBuilder: FormBuilder,
        private _localStorageService: LocalStorageService,
        private _sharedService: SharedService,
    ) {
        this.countries = this._localStorageService.getAppLocalStorageObject().countries;
        this.passengerFormGroup = this._formBuilder.group({
            id: [""],
            firstName: ["", Validators.required],
            lastName: ["", Validators.required],
            gender: [""],
            dateOfBirth: [""],
            idCardNumber: [""],
            nationalityId: [""],
            idCardImageName: [""],
            status: [1],
        });

        this.passengerNameFormControl.valueChanges
            .pipe(
                debounceTime(300),
                tap(() => (this.passengerNameIsLoading = true)),
                switchMap((value) => this._passengersService.searchPassengersByName({ name: value }).pipe(finalize(() => (this.passengerNameIsLoading = false)))),
            )
            .subscribe((passengers) => (this.filteredPassengersOptions = passengers));
    }

    onPassengerSelected(event: MatAutocompleteSelectedEvent) {
        this.passengerNameFormControl.setValue("", { emitEvent: false });
        const object = event.option.value as Passenger;
        if (!this.flightPassengers.filter((p) => p.id === object.id)[0]) {
            this.flightPassengers.push(object);
        }
    }

    drop(event: CdkDragDrop<any>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
    }

    moveFilteredPassengerToFlightList(reverse: boolean) {
        if (!reverse) {
            [...this.searchedPassengers].map((item, index) => {
                transferArrayItem(this.searchedPassengers, this.flightPassengers, index, index);
            });
        } else {
            [...this.flightPassengers].map((item, index) => {
                transferArrayItem(this.flightPassengers, this.searchedPassengers, index, index);
            });
        }
    }

    onSearchByFlightCode() {
        if (this.flightCodeFormControl.value === "") {
            this.flightCodeFormControl.setErrors({ required: true });
        } else {
            this._passengersService.searchPassengersByFlightCode(this.flightCodeFormControl.value).subscribe((result) => {
                this.searchedPassengers = [];
                if (result.length > 0) {
                    result.map((r) => {
                        if (!this.flightPassengers.filter((p) => p.id === r.id)[0]) {
                            this.searchedPassengers.push(r);
                        }
                    });
                } else {
                    this.flightCodeFormControl.setErrors({ notValid: true });
                }
            });
        }
        this.flightCodeFormControl.markAsTouched();
    }

    onSelectedTabChange(event: MatTabChangeEvent) {
        if (event.index === 0) {
            this.searchedPassengers = [];
            this.flightCodeFormControl.setValue("", { emitEvent: false });
        } else if (event.index === 2) {
            this.passengersForm.resetForm();
        }
    }

    removePassenger(index: number) {
        this.flightPassengers.splice(index, 1);
    }

    onNewPassengerFormSubmit() {
        // this.passengerFormGroup.get('idCardNumber').setErrors(null);
        // if (this.passengerFormGroup.get('gender').value !== 'I') {
        //   if (!this.passengerFormGroup.get('idCardNumber').value) {
        //     this.passengerFormGroup.get('idCardNumber').setErrors({ required: true });
        //   }
        // }
        if (this.passengerFormGroup.valid) {
            const object = this.passengerFormGroup.value as Passenger;
            object.status = 1;
            if (object.dateOfBirth) {
                object.dateOfBirth = moment(object.dateOfBirth).format("YYYY-MM-DD");
            }
            this.flightPassengers.push(object);
            this.passengersForm.resetForm();
        } else {
            const errors = this._sharedService.checkIfFormGroupHasError(this.passengerFormGroup);
            errors.map((error) => {
                this.passengerFormGroup.get(error.key).setErrors({ required: true });
                this.passengerFormGroup.get(error.key).markAsTouched();
            });
        }
    }

    submitPassengersList() {
        if (this.flightPassengers.length > 0) {
            this.flightPassengers.map((p) => {
                p.flightId = this._data.flightId;
                // p.luggageHeight = null;
                // p.luggageLength = null;
                // p.luggageWeight = null;
                // p.luggageWidth = null;
                // p.passengerWeight = null;
            });
            console.log("submitPassengersList()__this.flightPassengers:", this.flightPassengers);
            this._passengersService.updatePassengersList(this.flightPassengers).subscribe(() => {
                this.dialogRef.close();
                this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                    duration: 3000,
                });
            });
        }
    }
}
